import React from "react";
import { installmentCardLanguageOptions } from "./dropdown/dropdown-data";

const StatusUpdateModal = ({ message, onConfirm, onCancel, jwt }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-[90%] max-w-md">
        <div className="bg-blue-600 text-white px-4 py-3 rounded-t-lg">
          <h2 className="text-lg font-semibold"> {installmentCardLanguageOptions[jwt]?.title}</h2>
        </div>
        <div className="p-6 text-gray-800">
          <p dangerouslySetInnerHTML={{ __html: message }}></p>
        </div>
        <div className="flex justify-between px-6 pb-4">
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            onClick={onConfirm}
          >
            {installmentCardLanguageOptions[jwt]?.button[0]}
          </button>
          <button
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            onClick={onCancel}
          >
              {installmentCardLanguageOptions[jwt]?.button[1]}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusUpdateModal;
